import { PondSizeBase } from './base/pond-size-base';

export class PondSize extends PondSizeBase { }